import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';




function VehicleMaster(props) {
  const [rooms, setRooms] = useState([]);
  const [VehicleCode, setVehicleCode] = useState('');
  const [VehicleNo, setVehicleNo] = useState('');
  const [UserID, setUserID] = useState('');

  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [formMode, setFormMode] = useState('add');
  const [editRoomId, setEditRoomId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [VehicleMasterEntries, setVehicleMasterEntries] = useState([]);

  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  useEffect(() => {
    fetchVehicleMaster();
  }, []);

  const fetchVehicleMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/vehicle');
      setVehicleMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setVehicleCode(nextEntryNo);
      console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };


  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.VehicleCode > maxEntryNo) {
        maxEntryNo = entry.VehicleCode;
      }
    }
    return maxEntryNo;
  };

  const addVehicle = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/vehicle', {
        VehicleCode: VehicleCode,
        VehicleNo: VehicleNo,
        UserID: props.name,
      });
      fetchVehicleMaster();
      setVehicleCode('');
      setVehicleNo('');
      setUserID('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateVehicle = async (VehicleCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/vehicle/${VehicleCode}`, {
        VehicleCode: VehicleCode,
        VehicleNo: VehicleNo,
        UserID: props.name,
      });
      fetchVehicleMaster();
      setVehicleCode('');
      setVehicleNo('');
      setUserID('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };


  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteVehicle(deleteEntryNo.VehicleCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteVehicle = async (VehicleCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/vehicle/${VehicleCode}`, {
        headers: {
          'username': props.name,
        },
      });
      if (response.status === 200) {
        fetchVehicleMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  };

  const setEditForm = (room) => {
    setFormMode('edit');
    setVehicleCode(room.VehicleCode);
    setVehicleNo(room.VehicleNo);
    setUserID(room.UserID);
    setShowGrid(false);
  };


  //   const handleSearch = (searchQuery) => {
  //     const filtered = rooms.filter((room) => {
  //       // Convert room.RoomNo, room.districtName, etc., to strings before using includes
  //       const districtCode = room.districtCode.toString().toLowerCase();
  //       const districtName = room.districtName.toString().toLowerCase();
  //       const stateCode = room.stateCode.toString().toLowerCase();
  //       const stdCode = room.stdCode.toString().toLowerCase();

  //       // Check if any of the properties contain the searchQuery (converted to lowercase)
  //       return (
  //         districtCode.includes(searchQuery.toLowerCase()) ||
  //         districtName.includes(searchQuery.toLowerCase()) ||
  //         stateCode.includes(searchQuery.toLowerCase()) ||
  //         stdCode.includes(searchQuery.toLowerCase())
  //       );
  //     });

  //     // Update the DistrictMasterEntries state with the filtered results
  //     setDistrictMasterEntries(filtered);
  //   };

  //   // ... Rest of your code ...

  //   // Update the filtered rooms based on the searchQuery prop
  //   useEffect(() => {
  //     handleSearch(props.searchQuery);
  //   }, [props.searchQuery, rooms]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setRooms(rooms);
  }

  const handleCancel = () => {
    setFormMode('add');
    setEditRoomId('');
    setVehicleCode('');
    setVehicleNo('');
    setUserID('');
    fetchVehicleMaster();
  }

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "VehicleData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }} >
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Vehicle Master</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {!showGrid && (
        <>
          <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
            <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="VehicleCode" style={{ width: '150px', marginRight: '10px' }}>
                Vehicle Code
              </label>
              <input
                type="text"
                value={VehicleCode}
                readOnly
                placeholder="Vehicle Code"
                style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
              />
            </div>
            <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="VehicleNo" style={{ width: '150px', marginRight: '10px' }}>
                VehicleNo
              </label>
              <input
                type="text"
                value={VehicleNo}
                onChange={(e) => setVehicleNo(e.target.value)}
                placeholder="VehicleNo"
                style={{ marginBottom: '5px', padding: '5px', width: '15%' }}
              />
            </div>
            <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
              <label htmlFor="UserId" style={{ width: '150px', marginRight: '10px' }}>
                UserId
              </label>
              <input
                type="text"
                value={UserID}
                readOnly
                onChange={(e) => setUserID(e.target.value)}
                placeholder="UserId"
                style={{ marginBottom: '5px', padding: '5px', width: '15%' }}
              />
            </div>
          </div>
          <div>
            <button
              className={formMode === 'add' ? 'add-button' : 'update-button'}
              onClick={formMode === 'add' ? addVehicle : () => updateVehicle(VehicleCode)}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginBottom: '10px',
              }}
            >
              {formMode === 'add' ? 'Add' : 'Update'}
            </button>
            <button
              className="view-button"
              onClick={handleCancel}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                cursor: 'pointer',
                marginLeft: '10px',
                marginBottom: '10px',
              }}
            >
              Cancel
            </button>
          </div>
        </>
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  VehicleCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Vehicle No
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {VehicleMasterEntries.map((room) => (
                <tr key={room.VehicleCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.VehicleCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{room.VehicleNo}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(room)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setDeleteEntryNo({ VehicleCode: room.VehicleCode });
                        setOpenConfirmation(true);
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{ fontSize: '16px' }} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
        open={openConfirmation}
        onClose={() => setOpenConfirmation(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to DELETE ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmation(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default VehicleMaster;